import { LayoutGrid, LogOut, Menu, User, Users, ZoomIn } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui";
import { ROUTES } from "@/constants/routes";
import { useGetMe } from "@/services/api-hooks/user";
import { useAuthStore } from "@/store/auth.store";

export const NavbarMenu = () => {
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);
  const { data: user } = useGetMe();

  const handleLogout = () => {
    logout();
    navigate(ROUTES.LOGIN);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" aria-label="Menu">
          <Menu />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52 bg-background">
        {user?.email && (
          <>
            <DropdownMenuLabel className="truncate p-2 font-semibold text-foreground text-sm">
              {user.email}
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem asChild className="p-2">
          <Link to={ROUTES.AVATARS}>
            <Users />
            Avatars
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="p-2">
          <Link to={ROUTES.VIDEOS}>
            <LayoutGrid />
            Content
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="p-2">
          <Link to={ROUTES.PROFILE}>
            <User />
            Profile
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="p-2">
          <Link to={ROUTES.PROFILE_SUBSCRIPTION}>
            <ZoomIn />
            Manage Subscription
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={handleLogout} variant="destructive" className="p-2">
          <LogOut />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
